import React, { useState } from 'react'
import styles from './styles.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Sandbox = ({ children, open = false }) => {
  const [isOpen, setIsOpen] = useState(open)

  const toggleOpen = () => setIsOpen(!isOpen)

  const handleKeyDown = evt => {
    if (evt.keyCode === 13) {
      toggleOpen()
    }
  }

  return (
    <div className={styles.container}>
      <h3 className={`half-width-content`}>
        <span
          className={styles.header}
          data-testid="sandbox-header"
          onClick={toggleOpen}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex={0}
        >
          <span className={styles.headerContent}>
            <FontAwesomeIcon icon={['far', 'cube']} />
            Sandbox
          </span>
          <span className={`${styles.collapseIcon} ${isOpen && styles.open}`} data-testid="sandbox-careticon">
            <FontAwesomeIcon icon={['far', 'caret-circle-down']} />
          </span>
        </span>
      </h3>
      {isOpen && children}
    </div>
  )
}

export default Sandbox
